export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#363635',
    light: '#F6F6F6',
    after: '#6B5A9A',
  },
  secondary: {
    main: '#FFFFFF',
    light: '#D9EDF7',
  },
  text: {
    primary: '#22211F',
    secondary: '#4A5462',
    alternate: '#1F3B61',
    disabled: '#CCC',
    highlight: '#FFFFFF',
    success: '#1CA179',
    border: '#E5EAF4',
    content:'#1C1C1C'
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    hero1: '#5F4D43',
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#4E4E4E',
    footer: '#000000',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#363635',
    tableSubhead: '#F5F5F5',
    tableBorder: '#7D808880',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#26306E',
    secondary: '#F8D859',
    light: '#F8FBFE',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#D9EDF7',
    ribbon: '#bbe6fb',
    offer: '#E1F0FF',
    hover1: '#6B5A9A',
    pricing:'#363635',
    benefits:'#F7F7F7',
    stepcounter:'#F0F0EF'
  },
  surface: {
    light: '#F5F5F5',
    grey: '#F5F5F5',
    pricing: '#171616',
    learnMore: '#F4F4F4',
    header: '#EBF6FF',
    switch: '#313E50',
  },
  verticalBar: {
    used: '#687462',
    unused: '#F6F6F6',
    unlimited: '#C0C0C0',
  },
};
